import React from 'react';
import styled from 'styled-components/macro';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';


const ShortlistIconButton = observer(() => {
    const { shortlistStore } = useDataStore();
    
    return (
        <StyledButton
            onClick={() => shortlistStore.openPopup()}
            title={`${shortlistStore.shortlistedCount} shortlisted`}
        >
            <IconWrapper>
                <StyledIcon />
                <Badge>{shortlistStore.shortlistedCount}</Badge>
            </IconWrapper>
        </StyledButton>
    );
});


export default ShortlistIconButton;


const IconSvg = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="448" height="562" viewBox="0 0 448 562" {...props}>
        <path d="M160,96v64h128v-64c0-35.3-28.7-64-64-64s-64,28.7-64,64ZM128,192H48c-8.8,0-16,7.2-16,16v258c0,35.3,28.7,64,64,64h256c35.3,0,64-28.7,64-64V208c0-8.8-7.2-16-16-16h-80v50c0,8.8-7.2,16-16,16s-16-7.2-16-16v-50h-128v50c0,8.8-7.2,16-16,16s-16-7.2-16-16v-50ZM128,160v-64C128,43,171,0,224,0s96,43,96,96v64h80c26.5,0,48,21.5,48,48v258c0,53-43,96-96,96H96c-53,0-96-43-96-96V208c0-26.5,21.5-48,48-48h80Z"/>
    </svg>
);


const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-size: 3.8rem;
    
    color: white;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        color: ${props => props.theme.secondary_color_mid};
    }
`;

const IconWrapper = styled.div`
    position: relative;
    top: -.08em;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledIcon = styled(IconSvg)`
    width: auto;
    height: 1em;
    fill: currentColor;
`;

const Badge = styled.div`
    position: absolute;
    bottom: .2em;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    font-size: .44em;
    line-height: 1;
    font-weight: 600;
`;
